import { clamp } from '@ui/style/clamp-calculator';
import { between } from '@ui/style/style';
import { useResponsive } from '@ui/style/useResponsive';
import { headerHeight, spaceAboveHeader, spaceBelowHeader } from '@ui/style/variables';
export const useTasksStyles = () => {
    const { isMobileIpadNavigation } = useResponsive();
    const headingHeight = 48;
    const spaceBelowHeading = 34;
    const pageEndPadding = 8;
    const statusHeight = 52.8;
    const spaceAfterStatus = 12;
    const containerEndPadding = 8;
    const mobileTaskTabView = 89.18;
    const spaceBelowTabs = 8;
    const floatingButtonHeight = 84;
    const cardContainerHeightDesktop = `${spaceAboveHeader + headerHeight + spaceBelowHeader + headingHeight + spaceBelowHeading + pageEndPadding + statusHeight + spaceAfterStatus + containerEndPadding + 420}px`;
    const cardContainerHeightMobile = `${headerHeight + spaceAboveHeader + mobileTaskTabView + spaceBelowTabs + containerEndPadding + floatingButtonHeight}px`;
    return {
        taskHeaderButtonContainer: {
            display: 'flex',
            alignItems: 'center',
            gap: (theme) => theme.spacing(1)
        },
        mobileScreenHeader: {
            between,
            flexDirection: 'row',
            // backgroundColor: (theme) => alpha(theme.palette.common.black, 0.2),
            px: clamp.calculate(8, 32),
            // height: '100%',
            pb: 1
        },
        mobileScreenHeadingButton: {
            display: 'flex',
            justifyContent: 'space-between',
            flexDirection: 'row',
            alignItems: 'center'
        },
        createEventButton: {
            border: '1px solid #00244D',
            color: '#00244D'
        },
        tasksContainer: {
            // display: 'flex',
            overflow: 'auto',
            width: '100%',
            // px: 1,
            mt: 2,
            gap: (theme) => theme.spacing(2)
        },
        taskLabel: {
            color: (theme) => theme.palette.text.primary,
            backgroundColor: (theme) => theme.palette.common.white,
            width: 'auto',
            fontWeight: 400,
            px: 1.5,
            py: 1,
            borderRadius: 1.5
        },
        bottomNewTaskDrawer: {
            p: 2,
            backgroundColor: (theme) => theme.palette.common.white92,
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16
        }
    };
};
export default useTasksStyles;
